module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "ql-project-list-view"
  }, [_c('div', {
    staticClass: "ql-project-list-view-toolbar"
  }, [(_vm.splitView) ? _c('div', {
    staticClass: "list-view-split-bar"
  }, [_c('div', {
    ref: "splitLayers",
    staticClass: "ql-split-layers"
  }, [_c('button', {
    staticClass: "ql-split-layers-btn",
    class: {
      'is-open': _vm.splitLayersOpen,
      'is-filtered': _vm.splitLayersLabel !== 'All'
    },
    attrs: {
      "type": "button",
      "aria-haspopup": "true",
      "aria-expanded": _vm.splitLayersOpen ? 'true' : 'false'
    },
    on: {
      "click": function($event) {
        _vm.splitLayersOpen = !_vm.splitLayersOpen
      }
    }
  }, [_vm._v("\n                    Layers: " + _vm._s(_vm.splitLayersLabel)), _c('span', {
    staticClass: "ql-split-layers-caret"
  })]), _vm._v(" "), (_vm.splitLayersOpen) ? _c('div', {
    staticClass: "ql-split-layers-menu"
  }, [_vm._l((_vm.layers), function(layer) {
    return _c('label', {
      key: layer.id,
      staticClass: "ql-split-layer-option"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.visibleSplitLayerIDs.includes(layer.id)
      },
      on: {
        "change": function (e) { return _vm.changeSplitLayer(layer.id, e.target.checked); }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ql-split-layer-swatch",
      style: ({
        background: layer.color
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "ql-split-layer-name"
    }, [_vm._v(_vm._s(layer.title))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "ql-split-layers-foot"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showAllSplitLayers
    }
  }, [_vm._v("Show all")])])], 2) : _vm._e()]), _vm._v(" "), (_vm.projectTotalPages > 1) ? _c('label', {
    staticClass: "ql-split-page-sync"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localPageSync),
      expression: "localPageSync"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.localPageSync) ? _vm._i(_vm.localPageSync, null) > -1 : (_vm.localPageSync)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.localPageSync,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.localPageSync = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.localPageSync = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.localPageSync = $$c
        }
      }
    }
  }), _vm._v(" List Sync\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "ql-split-close",
    attrs: {
      "title": "Close list view",
      "aria-label": "Close list view"
    },
    on: {
      "click": _vm.closeSplitView
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), (!_vm.splitView) ? _c('div', {
    staticClass: "list-view-visible-layers"
  }, [_c('strong', {
    staticStyle: {
      "margin-right": "1rem"
    }
  }, [_vm._v("Visible Layers:")]), _vm._v(" "), _vm._l((_vm.layers), function(layer) {
    return _c('md-checkbox', {
      key: layer.id,
      staticStyle: {
        "margin-right": "1rem"
      },
      attrs: {
        "value": _vm.visibleListLayerIDs.includes(layer.id)
      },
      on: {
        "change": function (val) { return _vm.changeVisibleListLayer(layer.id, val); }
      }
    }, [_vm._v(_vm._s(layer.title))])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.splitView) ? _c('div', {
    staticClass: "list-view-auto-number"
  }, [_c('md-button', {
    staticClass: "md-raised",
    attrs: {
      "disabled": !_vm.selectedCueIds.length || _vm.numberingInProgress || _vm.deletingInProgress
    },
    on: {
      "click": _vm.openAutoNumberModal
    }
  }, [(_vm.numberingInProgress) ? _c('span', [_vm._v("Numbering...")]) : _c('span', [_vm._v("Auto Number Selected Cues")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    attrs: {
      "disabled": !_vm.selectedCueIds.length || _vm.numberingInProgress || _vm.deletingInProgress
    },
    on: {
      "click": _vm.openDeleteSelected
    }
  }, [(_vm.deletingInProgress) ? _c('span', [_vm._v("Deleting...")]) : _c('span', [_vm._v("Delete Selected Cues")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.splitView) ? _c('div', {
    staticClass: "list-view-export"
  }, [_c('strong', [_vm._v("Download all visible layers as a CSV file: ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    attrs: {
      "disabled": _vm.exporting
    },
    on: {
      "click": _vm.exportList
    }
  }, [(_vm.exporting) ? _c('span', [_vm._v("Exporting...")]) : _c('span', [_vm._v("Export")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.openEosModal
    }
  }, [_vm._v("Export for Eos")])], 1) : _vm._e()]), _vm._v(" "), (_vm.structureHiddenBySort && !_vm.splitView) ? _c('div', {
    staticClass: "ql-structure-sort-hint"
  }, [_vm._v("\n        Acts, Scenes, and Songs show only when sorted by page in ascending order.\n    ")]) : _vm._e(), _vm._v(" "), _c('auto-number-cues', {
    ref: "autoNumberCues",
    on: {
      "auto-number": _vm.onAutoNumber
    }
  }), _vm._v(" "), _c('md-dialog', {
    ref: "autoNumberOverwriteDialog"
  }, [_c('md-dialog-content', [_vm._v(_vm._s(_vm.overwriteCount) + " of the cues you have chosen to auto number already have a number. These cue numbers will be over-written by the auto number function. This cannot be undone.")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    on: {
      "click": _vm.cancelOverwrite
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.confirmOverwrite
    }
  }, [_vm._v("Auto Number")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "autoNumberResultDialog"
  }, [_c('md-dialog-content', [_vm._v(_vm._s(_vm.resultMessage))]), _vm._v(" "), _c('md-dialog-actions', [(_vm.lastNumbered.length) ? _c('md-button', {
    on: {
      "click": _vm.undoAutoNumber
    }
  }, [_vm._v("Undo")]) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.closeResultDialog
    }
  }, [_vm._v("Done")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "deleteSelectedDialog"
  }, [_c('md-dialog-content', [_vm._v("Delete " + _vm._s(_vm.selectedCueIds.length) + " selected " + _vm._s(_vm.selectedCueIds.length === 1 ? 'cue' : 'cues') + "? This cannot be undone.")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    on: {
      "click": _vm.cancelDeleteSelected
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.confirmDeleteSelected
    }
  }, [_vm._v("Delete")])], 1)], 1), _vm._v(" "), _c('md-layout', {
    ref: "ql-project-list-view-content",
    staticClass: "ql-project-list-view-content",
    class: {
      'ql-split-list': _vm.splitView
    }
  }, [_c('table', {
    staticClass: "ql-project-list-view-table"
  }, [_c('thead', {
    staticClass: "ql-project-list-view-table-fixed-header"
  }, [_c('tr', [_c('th', {
    staticClass: "ql-cell-empty ql-cell-select"
  }, [_c('md-checkbox', {
    attrs: {
      "value": _vm.allSelected
    },
    on: {
      "change": _vm.toggleSelectAll
    }
  }, [_vm._v("All")])], 1), _vm._v(" "), _c('th', {
    staticClass: "ql-cell-empty"
  }), _vm._v(" "), _c('th', {
    staticClass: "ql-cell-sortable",
    class: {
      'ql-sort-active': _vm.sortBy === 'page' && !_vm.splitView
    },
    on: {
      "click": function($event) {
        return _vm.toggleSortBy('page')
      }
    }
  }, [_vm._v("Page "), _c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sortBy === 'page' && _vm.sortAsc),
      expression: "sortBy === 'page' && sortAsc"
    }]
  }, [_vm._v("arrow_drop_down")]), _c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sortBy === 'page' && !_vm.sortAsc),
      expression: "sortBy === 'page' && !sortAsc"
    }]
  }, [_vm._v("arrow_drop_up")]), (!_vm.splitView) ? _c('md-tooltip', [_vm._v("Sort by page")]) : _vm._e()], 1), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    staticClass: "ql-cell-sortable",
    class: {
      'ql-sort-active': _vm.sortBy === 'layer' && !_vm.splitView
    },
    on: {
      "click": function($event) {
        return _vm.toggleSortBy('layer')
      }
    }
  }, [_vm._v("Layer "), _c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sortBy === 'layer' && _vm.sortAsc),
      expression: "sortBy === 'layer' && sortAsc"
    }]
  }, [_vm._v("arrow_drop_down")]), _c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sortBy === 'layer' && !_vm.sortAsc),
      expression: "sortBy === 'layer' && !sortAsc"
    }]
  }, [_vm._v("arrow_drop_up")]), (!_vm.splitView) ? _c('md-tooltip', [_vm._v("Sort by layer")]) : _vm._e()], 1), _vm._v(" "), _c('th', {
    staticClass: "ql-cell-sortable",
    class: {
      'ql-sort-active': _vm.sortBy === 'cue' && !_vm.splitView
    },
    on: {
      "click": function($event) {
        return _vm.toggleSortBy('cue')
      }
    }
  }, [_vm._v("Cue "), _c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sortBy === 'cue' && _vm.sortAsc),
      expression: "sortBy === 'cue' && sortAsc"
    }]
  }, [_vm._v("arrow_drop_down")]), _c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sortBy === 'cue' && !_vm.sortAsc),
      expression: "sortBy === 'cue' && !sortAsc"
    }]
  }, [_vm._v("arrow_drop_up")]), (!_vm.splitView) ? _c('md-tooltip', [_vm._v("Sort by cue number")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.availableColumns), function(attr) {
    return ((!['user1', 'user2', 'user3', 'user4', 'workNote'].includes(attr))) ? _c('th', {
      key: attr,
      class: 'ql-cell-attr-' + attr
    }, [_vm._v(_vm._s(_vm.attributes[attr]))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.availableColumns), function(attr) {
    return (('workNote' === attr)) ? _c('th', {
      key: attr,
      class: ['ql-cell-attr-' + attr, {
        'ql-cell-attr-workNote--noteslist': _vm.notesListLinked
      }]
    }, [_vm._v(_vm._s(_vm.notesListLinked ? 'Notes List' : _vm.attributes[attr]))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.getAllUserDefinedKeys()), function(key, udIndex) {
    return _c('th', {
      key: udIndex + '_' + key,
      class: 'ql-cell-attr-' + key
    }, [_vm._v("\n                        " + _vm._s(key) + "\n                    ")])
  })], 2)]), _vm._v(" "), (_vm.topSpacerHeight > 0) ? _c('tbody', {
    staticClass: "ql-vscroll-spacer"
  }, [_c('tr', [_c('td', {
    style: ({
      height: _vm.topSpacerHeight + 'px',
      padding: 0,
      border: 0
    }),
    attrs: {
      "colspan": "100"
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.windowedRows), function(item) {
    return [(item.row.kind === 'header') ? _c('project-list-view-structure-header-row', {
      key: item.row.key,
      attrs: {
        "marker": item.row.marker,
        "empty": item.row.isEmpty,
        "splitView": _vm.splitView
      },
      on: {
        "switchViewToPage": _vm.switchViewToPage
      }
    }) : _c('project-list-view-cue-row', {
      key: item.row.cue.id,
      attrs: {
        "cue": item.row.cue,
        "cueIndex": item.row.cueIndex,
        "layerUserDefined": _vm.layerUserDefined,
        "getAllUserDefinedKeys": _vm.getAllUserDefinedKeys,
        "getUserDefinedValue": _vm.getUserDefinedValue,
        "editable": _vm.isEditableCue(item.row.cue),
        "selected": _vm.isCueSelected(item.row.cue.id),
        "availableColumns": _vm.availableColumns,
        "notesListColumn": _vm.notesListColumn,
        "splitView": _vm.splitView
      },
      on: {
        "toggleSelect": _vm.toggleSelectCue,
        "switchViewToPage": _vm.switchViewToPage,
        "cellNavigate": _vm.onCellNavigate
      }
    })]
  }), _vm._v(" "), (_vm.bottomSpacerHeight > 0) ? _c('tbody', {
    staticClass: "ql-vscroll-spacer"
  }, [_c('tr', [_c('td', {
    style: ({
      height: _vm.bottomSpacerHeight + 'px',
      padding: 0,
      border: 0
    }),
    attrs: {
      "colspan": "100"
    }
  })])]) : _vm._e()], 2), _vm._v(" "), (_vm.splitView && _vm.allCues.length === 0) ? _c('div', {
    staticClass: "ql-split-empty"
  }, [_vm._v("\n            No layers shown in this list.\n        ")]) : _vm._e()]), _vm._v(" "), (_vm.flashMsg) ? _c('div', {
    staticClass: "ql-list-view-flash"
  }, [_vm._v(_vm._s(_vm.flashMsg))]) : _vm._e(), _vm._v(" "), (_vm.eosModalOpen) ? _c('div', {
    staticClass: "ql-eos-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.cancelEosModal.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "ql-eos-modal"
  }, [_c('div', {
    staticClass: "ql-eos-modal-title"
  }, [_vm._v("Export for ETC Eos")]), _vm._v(" "), _c('p', {
    staticClass: "ql-eos-modal-desc"
  }, [_vm._v("Cues with no time will be given this default time.")]), _vm._v(" "), _c('label', {
    staticClass: "ql-eos-modal-label"
  }, [_vm._v("Default Cue Time\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eosDefaultTime),
      expression: "eosDefaultTime"
    }],
    staticClass: "ql-eos-modal-input",
    attrs: {
      "type": "number",
      "step": "0.1",
      "min": "0"
    },
    domProps: {
      "value": (_vm.eosDefaultTime)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirmEosExport.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eosDefaultTime = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ql-eos-modal-actions"
  }, [_c('button', {
    staticClass: "ql-eos-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEosModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "ql-eos-btn ql-eos-btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.eosExporting
    },
    on: {
      "click": _vm.confirmEosExport
    }
  }, [_vm._v(_vm._s(_vm.eosExporting ? 'Exporting…' : 'Export'))])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c60ea71","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/list-view.vue
// module id = 1226
// module chunks = 21